import React, { useState } from 'react';
import { API_CONFIG } from '../config/api';

const PasswordResetRequest = () => {
  const [identifier, setIdentifier] = useState(''); // email or username
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setMessage(''); setError('');
    try {
      const body = identifier.includes('@') ? { email: identifier } : { username: identifier };
      const res = await fetch(API_CONFIG.ENDPOINTS.PASSWORD_FORGOT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Neuspješan zahtjev.');
      setMessage('Ako nalog postoji, poslat ćemo upute za reset lozinke.');
      // For dev: show link
      if (data.resetUrl) {
        setMessage(m => m + `\nDev link: ${data.resetUrl}`);
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl shadow-sm p-6 md:p-8">
        <h1 className="text-2xl font-semibold text-gray-900">Reset lozinke</h1>
        <p className="text-sm text-gray-600 mt-1">Unesite email ili korisničko ime kako bismo poslali upute.</p>
        <form onSubmit={handleSubmit} className="mt-4 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Email ili korisničko ime</label>
            <input
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              required
              className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-3"
            />
          </div>
          {message && <div className="p-3 text-sm text-green-700 bg-green-100 rounded-md whitespace-pre-wrap">{message}</div>}
          {error && <div className="p-3 text-sm text-red-700 bg-red-100 rounded-md">{error}</div>}
          <button type="submit" disabled={loading} className="w-full py-3 rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50">
            {loading ? 'Slanje...' : 'Pošalji upute'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordResetRequest;
